/* eslint-disable react/no-deprecated */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-this-alias */

'use client';
import {
  chartDefined,
  rangeDay,
  rangeMonthQuarter,
  rangeYear,
  typeChart,
} from '@/statics/data';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import HighCharts from 'highcharts';
import dynamic from 'next/dynamic';
import {
  generateGUID,
  mapModifiers,
  notify,
  parseToExport,
  slugifyFileName,
} from '@/utils/funtion';
import Dropdown from '@/components/atoms/dropdown';
import { itemsMenu } from '@/statics/static';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import HighChartsReact from 'highcharts-react-official';
import ExportDataOffline from 'highcharts/modules/offline-exporting';
import HighChartsFullscreen from 'highcharts/modules/full-screen';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import { Empty, Spin as AntSpin } from 'antd';
import { FiChevronLeft, FiChevronRight, FiDownload } from 'react-icons/fi';
import Checkbox from '@/components/atoms/checkbox';
import { useData } from '@/stores/context';
import Spin from '@/components/atoms/spin';
import base64Logo from '@/assets/base64/logo.json';
import { AiOutlineFullscreen } from 'react-icons/ai';
import { ISelectType } from '@/components/atoms/select';
import Button from '@/components/atoms/button';
import { useSelector } from 'react-redux';
import PermissionModal from '@/components/organisms/permission-modal';
import {
  FaArrowUpRightFromSquare,
  FaReact,
  FaRegEye,
  FaRegEyeSlash,
  FaRegSquarePlus,
  FaRotate,
  FaTrash,
} from 'react-icons/fa6';
import { BsDatabaseCheck } from 'react-icons/bs';
import useGetNewPlans from '@/helpers/useGetNewPlans';
import { checkDownloadStatus } from '@/services/apis/modules/plans';
import Table from '@/components/molecules/table';
import AutoComplete from '@/components/atoms/autoComplete';
import {
  getCompareDetail,
  getCompareList,
} from '@/services/apis/modules/indicators';
import { ResponseCompareData } from '@/interfaces/common';
import Pagination from '@/components/atoms/pagination';
import Skeleton from '@/components/atoms/skeletons';
import useClickOutside, { useDebounce } from '@/helpers/hook';
import 'highcharts/modules/boost';
import PopupConfirm from '@/components/molecules/popupConfirm';
import { registerAPI } from '@/services/apis/modules/home';
import { CommonIndicator, DataIsOBjectOneTime, DataIsStructure } from './type';
import { useUnauthorized } from '@/stores/context/unauthorized';

Exporting(HighCharts);
ExportData(HighCharts);
OfflineExporting(HighCharts);
ExportDataOffline(HighCharts);
HighChartsFullscreen(HighCharts);

const Select = dynamic(() => import('@/components/atoms/select'), {
  ssr: false,
});

interface ChartPackageProps {
  data: any;
  id: string;
  name: string;
  unit: string;
  original: string;
  typeData: string;
  dataType: string;
  parentId: string;
  chartType: string;
  loading?: boolean;
  isPageDetail?: boolean;
  originalUrl: string;
  slug?: string;
  isTwoUnit?: boolean | undefined;
  isStructure: boolean | undefined;
  isObjectOneTime?: boolean | undefined;
  isHiddenHeader?: boolean;
  chartHeight?: number;
  captionSize?: number;
  isTopPgae?: boolean;
  isHomePage?: boolean;
  handleClickRangeTime: (data: any) => void;
}

const colors = [
  '#007AFF',
  '#34C759',
  '#FF3B30',
  '#FF9500',
  '#AF52DE',
  '#FFCC00',
  '#5AC8FA',
  '#5856D6',
  '#FF2D55',
  '#32D74B',
  '#E5E5EA',
  '#8E8E93',
  '#D1D1D6',
  '#FF9F0A',
  '#FFD60A',
  '#0A84FF',
  '#30D158',
  '#BF5AF2',
];
HighCharts.setOptions({ colors: colors });

const fontSize = {
  style: {
    fontSize: '15px',
    fontWeight: 'normal',
  },
};

const mappingType: Record<string, string> = {
  year: 'Y',
  month: 'M',
  quarter: 'Q',
};

const mappingGroupData: Record<string, string> = {
  indicator: 'indicator',
  industry_indicator: 'industry',
};

const zIndexMapping: Record<string, number> = {
  area: 0,
  column: 1,
  line: 2,
};

const ChartPackage: React.FC<ChartPackageProps> = ({
  data = [],
  handleClickRangeTime,
  name,
  original,
  unit,
  originalUrl,
  id,
  chartType,
  dataType,
  loading: propsLoading = false,
  isStructure = false,
  isTwoUnit,
  isObjectOneTime,
  isHiddenHeader = false,
  chartHeight = 540,
  captionSize = 17,
  parentId,
  typeData,
  isPageDetail = false,
  isTopPgae = false,
  isHomePage = false,
  slug,
}) => {
  const {
    innerWidth,
    handleSetStatusAssitant,
    handleSetDataQuestion,
    handleSetAutoPlay,
  } = useData();
  const { handleOpenUnauthorized } = useUnauthorized();

  const userData = useSelector((state: any) => state.userData);
  const chartRef = useRef(null);
  const chartWrapperRef = useRef(null);
  const { fetchNewPlan } = useGetNewPlans();

  const [state, setState] = useState({
    loading: propsLoading,
    loadingDownload: false,
    isFullscreen: false,
    isHiddenHeader: isHiddenHeader,
    showIndicatorInColumn: false,
    range: 12,
    rangeTime: '',
    downloadSuccess: false,
    pie: { index: 0, data: [], max: 1 },
    setting: {
      type: typeChart.length > 0 ? typeChart[0] : { value: undefined },
    },
    customize: {
      check: false,
      open: false,
      data: [] as any,
    },
    compare: {
      open: false,
      loading: false,
      openList: false,
      pageSize: 10,
      pageIndex: 1,
      list: [] as any,
      result: [] as any,
      total: 0,
      keyword: '',
      value: undefined as any,
      listPageDisable: [] as number[],
    },
    api: {
      open: false,
      loading: false,
    },
    modal: { title: '', open: false },
  });

  const [config, setConfig] = useState<Record<string, any>>({
    credits: { enabled: false },
    caption: {},
    chart: {},
    title: {},
    subtitle: {},
    xAxis: {
      categories:
        !isObjectOneTime && !isTwoUnit && !isStructure
          ? (data || [])?.map((item: any) => renderTime(dataType, item))
          : (data?.response || [])?.map((item: any) => item.name) ||
            (data || [])[0]?.indicatorValue?.map((item: any) =>
              renderTime(dataType, item),
            ) ||
            (data || [])[0]?.values?.map((item: any) =>
              renderTime(dataType, item),
            ) ||
            (data?.response || [])[0]?.values?.map((item: any) =>
              renderTime(dataType, item),
            ) ||
            [],
      crosshair: true,
      visible: true,
    },
    yAxis: {},
    legend: {
      enabled: !isObjectOneTime && !isTwoUnit && !isStructure ? false : true,
      x: 0,
      y: -10,
      verticalAlign: 'top',
      layout: 'horizontal',
      rtl: false,
      align: 'right',
      itemWidth: state.isFullscreen ? undefined : (245 as any),
      reversed: true,
      labelFormatter: function (this: any) {
        return this.name;
      },
    },
    tooltip: {},
    plotOptions: {},
    series: [],
    colors: colors,
    exporting: {
      enabled: false,
      width: 1920,
      printMaxWidth: 1920,
      sourceWidth: 1920,
      sourceHeight: 1024,
      fallbackToExportServer: false,
      pdfFont: {
        normal: 'fonts/Roboto-Regular.ttf',
      },
    },
  });

  useClickOutside(chartWrapperRef, () => {
    setState((prev) => ({
      ...prev,
      compare: {
        ...prev.compare,
        open: false,
        openList: false,
        loading: false,
      },
    }));
  });

  function renderTime(type: string, data: any) {
    switch (type) {
      case 'year':
        return data?.year?.toString();
      case 'month':
        return `T${data?.month}-${data?.year}`;
      case 'quarter':
        return `Q${data?.quarter}-${data?.year}`;
      default:
        return `${data?.day}-${data?.month}-${data?.year}`;
    }
  }

  function sortTimes(type: string, list: string[]) {
    if (!list || !Array.isArray(list) || list.length === 0) {
      return [];
    }

    return list.sort((a, b) => {
      if (!a || !b) return 0;

      const parseTime = (str: string, type: string) => {
        try {
          switch (type) {
            case 'year': {
              const year = parseInt(str, 10);
              return { year, month: 0, day: 0, quarter: 0 };
            }
            case 'month': {
              const [month, year] = str
                .split('-')
                .map((s) => parseInt(s.replace('T', ''), 10));
              return { year, month, day: 0, quarter: 0 };
            }
            case 'quarter': {
              const [quarter, year] = str
                .split('-')
                .map((s) => parseInt(s.replace('Q', ''), 10));
              return { year, quarter, month: quarter * 3, day: 0 };
            }
            case 'day': {
              const [day, month, year] = str.split('-').map(Number);
              return { year, month, day, quarter: Math.ceil(month / 3) };
            }
            default:
              console.warn(
                `Invalid type: ${type}, falling back to default sorting`,
              );
              return { year: 0, month: 0, day: 0, quarter: 0 };
          }
        } catch (error) {
          console.warn(`Error parsing time: ${str}, type: ${type}`);
          return { year: 0, month: 0, day: 0, quarter: 0 };
        }
      };

      const timeA = parseTime(a, type);
      const timeB = parseTime(b, type);

      return (
        timeA.year - timeB.year ||
        timeA.month - timeB.month ||
        timeA.day - timeB.day
      );
    });
  }

  const complieData = useMemo(() => {
    if (!isObjectOneTime && !isTwoUnit && !isStructure) return data;
    let group: (string | number)[] = [];
    let groupRreverse: (string | number)[] = [];
    let output: CommonIndicator[] = [];

    let listUnit: { id: string[]; unit: string }[] = [];
    for (const item of data || []) {
      const existingUnit = listUnit.find((i) => i.unit === item.unit);
      if (!existingUnit) {
        listUnit.push({ id: [item.id], unit: item.unit });
      }

      if (existingUnit && !item.isYAxis) {
        existingUnit.id.push(item.id);
      }

      if (item.isYAxis) {
        listUnit.push({ id: [item.id], unit: item.unit });
      }
      continue;
    }

    group = Array.from(
      new Set([
        ...data
          .flatMap((item: any) => item.indicatorValue)
          .map((i: any) =>
            isObjectOneTime ? i.name : renderTime(dataType, i),
          ),
        ...(!!state.compare.result.length
          ? (state.compare.result || [])
              .flatMap((item: any) => item.indicatorValue)
              .map((i: any) =>
                isObjectOneTime ? i.name : renderTime(dataType, i),
              )
          : []),
      ]),
    );
    groupRreverse = (data?.response || data || [])?.map(
      (item: any) => item.name,
    );

    if (isObjectOneTime) {
      output = data?.map((item: DataIsOBjectOneTime, index: number) => ({
        id: item.id,
        name: item.name,
        isYAxis: item.isYAxis,
        softName: item.softName,
        slug: item.slug,
        chartType: item.chartType,
        unit: item.unit,
        indicatorValue: (item.indicatorValue || [])?.map((i: any) => ({
          id: i.id,
          value: i.value,
          year: i.year,
          quarter: i.quarter,
          month: i.month,
          day: i.day,
        })),
      }));
    }

    if (isStructure) {
      output = data.map((item: DataIsStructure, index: number) => ({
        id: item.id,
        name: item.name,
        isYAxis: item.isYAxis,
        softName: item.softName,
        slug: item.slug,
        chartType: item.chartType,
        unit: item.unit,
        indicatorValue: (item.indicatorValue || [])?.map((i: any) => ({
          id: i.id,
          value: i.value,
          year: i.year,
          quarter: i.quarter,
          month: i.month,
          day: i.day,
        })),
      }));
    }

    return { group, groupRreverse, listUnit, output };
  }, [id, state.setting.type.value, data, state.compare]);

  const chart = useCallback(() => {
    const getChartWrapperElement = document.querySelector(
      '.t-chart_package_content',
    );

    const getChartSize = () => {
      const wrapperWidth = Number(getChartWrapperElement?.clientWidth) || 0;

      const getWidth = () => {
        if (isHiddenHeader) return null;
        if (isPageDetail) return wrapperWidth - 20;
        if (isTopPgae) return null;
        if (isHomePage && innerWidth > 1280)
          return Number(getChartWrapperElement?.clientWidth) - Number(80);
        if (innerWidth > 1280)
          return Number(getChartWrapperElement?.clientWidth) - Number(20);
        return null;
      };

      const getHeight = () => {
        if (state.isFullscreen) return '100%';
        if (state.isHiddenHeader) return null;
        if (isPageDetail && innerWidth > 1280) return 700;
        if (isPageDetail) return 600;
        if (innerWidth < 960 && innerWidth > 600) return 600;
        if (innerWidth < 600) return 500;
        return 690;
      };

      return {
        width: getWidth(),
        height: getHeight(),
      };
    };

    const commonChart = {
      animation: false,
      ...getChartSize(),
      marginBottom: isHiddenHeader ? 100 : 130,
      events: {
        async render() {
          const chart: any = this;
          if (isHiddenHeader || innerWidth < 450) return;
          chart['customImage']?.destroy();
          const widthHeight = state.isFullscreen
            ? 400
            : innerWidth < 600
              ? 130
              : 70;
          const plotWidth =
            state.isFullscreen || innerWidth < 600
              ? chart.plotWidth / 2 - (innerWidth < 600 ? 50 : 200)
              : chart.plotWidth - 10;
          const chartHeight =
            state.isFullscreen || innerWidth < 600
              ? chart.chartHeight / 2 - (innerWidth < 600 ? 50 : 200)
              : chart.chartHeight - 80;
          const logoProps = [plotWidth, chartHeight, widthHeight, widthHeight];
          chart.customImage = chart.renderer
            .image(base64Logo.data, ...logoProps)
            .attr({ opacity: state.isFullscreen || innerWidth < 600 ? 0.4 : 1 })
            .add();
        },
        fullscreenClose: () =>
          setState((prev) => ({ ...prev, isFullscreen: false })),
      },
      zooming: { type: undefined },
      style: { fontFamily: 'Noto Sans, Arial, sans-serif' },
    };

    const typeMapping: Record<string, any> = {
      bar: 'bar',
      line: 'line',
      area: 'area',
      column_line: { type: 'column', zooming: { type: 'xy' } },
      stack_value: 'column',
      stack_percent: 'column',
      column: 'column',
      object: 'column',
      group_column: 'column',
      pie: {
        ...commonChart,
        width: isHiddenHeader
          ? null
          : Number(getChartWrapperElement?.clientWidth) -
            Number(isTopPgae ? 20 : 80),
        height: state.isFullscreen
          ? '100%'
          : isHiddenHeader
            ? null
            : Number(getChartWrapperElement?.clientHeight) - 50,
        marginBottom: isHiddenHeader ? 100 : 130,
        type: 'pie',
        events: {
          ...commonChart.events,
          async render() {
            if (isHiddenHeader) return;
            const chart: any = this;
            chart['customImage']?.destroy();

            const widthHeight = innerWidth < 450 ? 180 : 100;
            const plotWidth = state.isFullscreen
              ? chart.plotWidth / 2 - 200
              : chart.plotWidth - 100;
            const chartHeight = state.isFullscreen
              ? chart.chartHeight / 2 - 200
              : chart.chartHeight - 120;
            const logoProps = [
              plotWidth,
              chartHeight,
              widthHeight,
              widthHeight,
            ];
            chart.customImage = chart.renderer
              .image(base64Logo.data, ...logoProps)
              .attr({ opacity: 1 })
              .add();
          },
        },
      },
    };
    const type = {
      ...(typeof typeMapping[
        state.setting.type.value?.replaceAll('-', '_') as string
      ] === 'string'
        ? {
            type: typeMapping[
              state.setting.type.value?.replaceAll('-', '_') as string
            ],
          }
        : typeMapping[
            state.setting.type.value?.replaceAll('-', '_') as string
          ]),
    };

    const chartConfig = {
      ...commonChart,
      ...type,
      zooming: {
        type: null,
      },
    };
    return chartConfig;
  }, [state.setting.type.value, state.isFullscreen, state.isHiddenHeader]);

  const xAxis = useCallback(() => {
    const { group, groupRreverse } = complieData;

    const categories =
      !isObjectOneTime && !isTwoUnit && !isStructure
        ? (data || []).map((item: any) => renderTime(dataType, item))
        : group || [];

    const listTimeCompare = state.compare.result.flatMap(
      (i: any) => i.indicatorValue,
    );
    const uniqueItemsCompare = Array.from(
      new Set(
        [...listTimeCompare, ...data].map((item: any) =>
          renderTime(dataType, item),
        ),
      ),
    ).sort((a, b) => a - b);
    const commonXAxis = {
      categories: isObjectOneTime
        ? data.map((i: any) => i.name)
        : !state.compare.result.length
          ? sortTimes(dataType, categories)
          : uniqueItemsCompare,
      crosshair: true,
      visible: true,
      labels: {
        style: {
          fontSize: '16px',
          fontWeight: 'normal',
          color: '#333',
        },
      },
    };

    switch (state.setting.type.value) {
      case 'bar':
      case 'stack-value':
      case 'stack-percent':
      case 'column':
      case 'area':
      case 'line':
      case 'column-line':
        return commonXAxis;
      case 'object':
        return {
          categories: (data?.response || data || [])?.map(
            (item: any) => item.name,
          ),
          crosshair: true,
          visible: true,
        };
      case 'pie':
        return { categories: [], crosshair: true, visible: false };
      case 'group-column':
        return {
          categories: groupRreverse,
          crosshair: true,
          visible: true,
        };
    }
  }, [
    data,
    dataType,
    state.setting.type.value,
    state.compare.result,
    state.customize.check,
    state.customize,
  ]);

  const yAxis = useCallback(() => {
    const { listUnit } = complieData;
    const commonFormat = {
      formatter: function (this: any) {
        if (Math.abs(this.value) >= 1000000) {
          return this.value / 1000000 + 'M';
        } else if (Math.abs(this.value) >= 1000) {
          return this.value / 1000 + 'K';
        }
        return this.value;
      },
    };

    const createYAxis = (
      titleText: string,
      color: string,
      opposite = false,
      length: number = 0,
    ) => ({
      title: {
        text: length == 1 && !titleText ? unit : titleText,
        style: {
          fontSize: 16,
          wordSpacing: 4,
          fontFamily: 'Arial, sans-serif',
          fontStyle: 'normal',
          fontWeight: 400,
          color,
        },
      },
      labels: {
        distance: 5,
        style: {
          fontSize: 16,
          color,
        },
        ...commonFormat,
      },
      opposite,
    });

    const createCustomYAxis = (data: any[]) =>
      (data || [])
        .map((item: any, index: number) =>
          createYAxis(
            item.unit,
            colors[index],
            index % 2 === 1,
            listUnit.length,
          ),
        )
        .filter(Boolean);

    switch (state.setting.type.value) {
      case 'column':
      case 'bar':
      case 'line':
      case 'stack-value':
      case 'area':
      case 'object':
      case 'stack-percent':
      case 'group-column':
        if (!isObjectOneTime && !isTwoUnit && !isStructure)
          return [
            {
              title: {
                text: unit,
                style: {
                  fontSize: 16,
                  wordSpacing: 4,
                  fontFamily: 'Arial, sans-serif',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  color: colors[0],
                },
              },
              labels: {
                distance: 5,
                style: {
                  fontSize: 16,
                  color: colors[0],
                },
                ...commonFormat,
              },
            },
          ];
        return createCustomYAxis(listUnit);
      case 'column-line':
        if (state.customize.check && state.customize.data) {
          let indexUnitActive = 0;
          const dataCustomize = state.customize.data
            .map((i: any, index: number) => {
              if (!i.isYAxis) return;
              indexUnitActive++;
              return {
                title: {
                  text: i?.unit || '',
                  style: {
                    fontSize: 16,
                    wordSpacing: 4,
                    fontFamily: 'Arial, sans-serif',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    color: colors[index],
                  },
                },
                labels: {
                  distance: 5,
                  style: {
                    fontSize: 16,
                    color: colors[index],
                  },
                  ...commonFormat,
                },
                opposite: indexUnitActive % 2 == 0,
              };
            })
            .filter(Boolean);

          return dataCustomize;
        }

        return createCustomYAxis(listUnit);
      case 'pie':
        return [];
    }
  }, [
    data,
    state.setting.type.value,
    state.customize.check,
    state.customize.data,
    unit,
    colors,
    isObjectOneTime,
  ]);

  const plotOptions = useCallback(() => {
    switch (state.setting.type.value) {
      case 'column':
        return {
          column: {
            stacking:
              !isObjectOneTime && !isTwoUnit && !isStructure
                ? !!state.compare.result.length
                  ? undefined
                  : 'normal'
                : undefined,
            borderWidth: 0,
          } as any,
        };
      case 'bar':
        return {
          bar: {
            pointPadding: 0.1,
            borderWidth: 0,
            stacking:
              !isObjectOneTime && !isTwoUnit && !isStructure
                ? !!state.compare.result.length
                  ? undefined
                  : 'normal'
                : undefined,
          },
          series: {
            borderWidth: 0,
            lineWidth: 4,
          },
        };
      case 'line':
        return {
          series: {
            marker: { enabled: false },
            lineWidth: 4,
            turboThreshold: 3000,
          },
        };
      case 'area':
        return {
          area: {
            pointPadding: 0.1,
            borderWidth: 0,
            turboThreshold: 3000,
            pointStart: 1940,
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
          },
          series: {
            stacking:
              !isObjectOneTime && !isTwoUnit && !isStructure
                ? !!state.compare.result.length
                  ? undefined
                  : 'normal'
                : undefined,
          },
        };
      case 'stack-value':
        return {
          column: {
            borderRadius: 0,
            turboThreshold: 3000,
            stacking: 'normal',
          } as any,
          series: {
            dataLabels: {
              color: 'contrast',
              enabled: state.showIndicatorInColumn,
              format: '{point.y:.2f}',
              formatter: function (this: any) {
                return this.y % 1 === 0
                  ? this.y.toLocaleString('fr-FR').replace(',', '  ')
                  : HighCharts.numberFormat(this.y, 2, '.', ',');
              },
              ...fontSize,
            },
          },
        };
      case 'stack-percent':
        return {
          column: {
            stacking: 'percent',
            borderRadius: 0,
            turboThreshold: 3000,
          } as any,
          series: {
            dataLabels: {
              color: 'contrast',
              enabled: state.showIndicatorInColumn,
              format: '{point.percentage:.0f}%',
              ...fontSize,
            },
          },
        };

      case 'column-line':
        return {
          column: {
            stacking: undefined,
            dataLabels: {
              enabled: state.showIndicatorInColumn,
              format: '{point.y:.2f}',
              color: 'contrast',
              ...fontSize,
            },
          } as any,
          line: {
            stacking: undefined,
            dataLabels: {
              enabled: state.showIndicatorInColumn,
              format: '{point.y:.2f}',
              color: 'contrast',
              ...fontSize,
            },
          } as any,
          area: {
            stacking: undefined,
            dataLabels: {
              enabled: state.showIndicatorInColumn,
              format: '{point.y:.2f}',
              color: 'contrast',
              ...fontSize,
            },
          },
          series: {
            marker: { enabled: false },
            lineWidth: 4,
            turboThreshold: 300,
            stacking: undefined,
          },
        };
      case 'object':
        return {
          column: {
            stacking: undefined,
            pointPadding: 0.1,
            borderWidth: 0,
            turboThreshold: 3000,
          } as any,
        };
      case 'pie':
        return {
          series: {
            cursor: 'pointer',
            turboThreshold: 3000,
          },
        };
      case 'group-column':
        return {
          series: {
            borderWidth: 0,
            lineWidth: 4,
            stacking: undefined,
            turboThreshold: 3000,
          },
        };
    }
  }, [
    state.setting.type.value,
    state.showIndicatorInColumn,
    state.compare.result,
  ]);

  const getSeries = useCallback(() => {
    const { group, listUnit, output } = complieData;

    const listTimeCompare = state.compare.result.flatMap(
      (i: any) => i.indicatorValue,
    );
    const uniqueItemsCompare = Array.from(
      new Set([
        ...[...listTimeCompare].map((item: any) => renderTime(dataType, item)),
        group,
      ]),
    )
      .filter(Boolean)
      .sort((a, b) => Number(a) - Number(b));

    const normalSeries = {
      name: name || '',
      data: (data || [])?.map((i: any) => {
        return parseFloat(parseFloat(i?.value).toFixed(2));
      }),
      zones: !state.compare.result.length
        ? [
            {
              value:
                !isObjectOneTime && !isTwoUnit && !isStructure ? 0 : undefined,
              color:
                !isObjectOneTime && !isTwoUnit && !isStructure
                  ? 'red'
                  : undefined,
            },
          ]
        : [],
      tooltip: {
        valueDecimals: 2,
      },
      ...(!['stack-value', 'stack-percent'].includes(
        state.setting.type.value as string,
      ) && {
        dataLabels: {
          enabled: state.showIndicatorInColumn,
          nullFormat: true,
          color: 'contrast',
          ...fontSize,
        },
      }),
    };

    const normalCompareSeries = state.compare.result.map((item: any) => ({
      name: item.name || '',
      data:
        uniqueItemsCompare.map((y) => {
          const check = item?.indicatorValue?.find(
            (i: any) => renderTime(dataType, i) == y,
          );
          if (check) return parseFloat(parseFloat(check?.value).toFixed(2));
          return NaN;
        }) || [],
      zones: state.compare.result?.length
        ? []
        : [
            {
              value:
                !isObjectOneTime &&
                !isTwoUnit &&
                !isStructure &&
                !state.compare.result
                  ? 0
                  : undefined,
              color:
                !isObjectOneTime &&
                !isTwoUnit &&
                !isStructure &&
                !state.compare.result
                  ? 'red'
                  : undefined,
            },
          ],
      tooltip: {
        valueDecimals: 2,
      },
      ...(!['stack-value', 'stack-percent'].includes(
        state.setting.type.value as string,
      ) && {
        dataLabels: {
          enabled: state.showIndicatorInColumn,
          nullFormat: true,
          color: 'contrast',
          ...fontSize,
        },
      }),
    }));

    const structureSeries = (output || []).map((item: any, index: number) => {
      const findIndexUnit = listUnit.findIndex(
        (i: { id: string[]; unit: string }) =>
          i.id.includes(item.id) && i.unit === item.unit,
      );

      const data =
        group.map((y: string) => {
          const value = item?.indicatorValue?.find(
            (i: any) => renderTime(dataType, i) === y,
          )?.value;
          return value !== undefined
            ? parseFloat(Number(value)?.toFixed(2))
            : NaN;
        }) ||
        item?.values?.map((i: any) =>
          parseFloat(Number(i?.value).toFixed(2)),
        ) ||
        [];

      return {
        data,
        color: colors[index],
        yAxis: findIndexUnit,
        name: item.name || '',
        allowPointSelect: true,
        tooltip: { valueDecimals: 2 },
        zones:
          !isObjectOneTime && !isTwoUnit && !isStructure
            ? [{ value: 0, color: 'red' }]
            : [],
        type: ['stack-value', 'stack-percent'].includes(
          state.setting.type.value as string,
        )
          ? 'column'
          : (state.setting.type.value as string),
        zIndex: zIndexMapping[item.chartType],
        ...(!['stack-value', 'stack-percent'].includes(
          state.setting.type.value as string,
        ) && {
          dataLabels: {
            enabled: state.showIndicatorInColumn,
            format: '{point.y:.2f}',
            color: 'contrast',
            ...fontSize,
          },
        }),
      };
    });

    const commonSeries = !isStructure
      ? [normalSeries, ...normalCompareSeries]
      : structureSeries;
    switch (state.setting.type.value) {
      case 'bar':
      case 'column':
      case 'area':
        return commonSeries;
      case 'line':
        return isObjectOneTime
          ? Array.from(
              new Map(
                data
                  .flatMap((item: any) => item.indicatorValue)
                  .map((item: any) => [item.name, item]),
              ).values(),
            )?.map((item: any, index: number) => {
              const findIndexUnit = listUnit.findIndex(
                (i: { id: string[]; unit: string }) =>
                  i.id.includes(item.id) && i.unit === item.unit,
              );
              return {
                type: 'line',
                name: item.name,
                allowPointSelect: true,
                data: data.map(
                  (i: { indicatorValue: { value: any }[] }) =>
                    i.indicatorValue.find((iv: any) => iv.name === item.name)
                      ?.value || null,
                ),
                lineWidth: 4,
                yAxis: findIndexUnit !== -1 ? findIndexUnit : 0,
                zIndex: zIndexMapping[item.chartType],
                dataLabels: {
                  enabled: state.showIndicatorInColumn,
                  nullFormat: true,
                  color: 'contrast',
                  ...fontSize,
                },
              };
            })
          : commonSeries;
      case 'stack-value':
      case 'stack-percent':
        if (!isObjectOneTime) return commonSeries;
        const genSeriesObjectOneTime = Array.from(
          new Map(
            data
              .flatMap((item: any) => item.indicatorValue)
              .map((item: any) => [item.name, item]),
          ).values(),
        ).map((item: any) => {
          const findIndexUnit = listUnit.findIndex(
            (i: { id: string[]; unit: string }) =>
              i.id.includes(item.id) && i.unit === item.unit,
          );
          return {
            name: item.name,
            type: 'column',
            data: data?.map((i: any) => {
              const getIndex = (i.indicatorValue || []).findIndex(
                (y: any) => y.name === item.name,
              );
              return getIndex !== -1 ? i.indicatorValue[getIndex].value : null;
            }),

            allowPointSelect: true,
            zIndex: zIndexMapping[item.chartType],
            yAxis: findIndexUnit !== -1 ? findIndexUnit : 0,
          };
        });
        return genSeriesObjectOneTime;
      case 'column-line':
        if (state.customize.check && state.customize.data) {
          let yAxisIndex = 0;
          const listYAxisUnit: string[] = [];

          const customizeSeries = state.customize.data.map(
            (customizeItem: any, _: number) => {
              const checkUnitExit = listYAxisUnit.includes(customizeItem.unit);
              if (!checkUnitExit || customizeItem.isYAxis) {
                yAxisIndex++;
                listYAxisUnit.push(customizeItem.unit);
                return {
                  name: customizeItem.name || '',
                  data:
                    group.map((y: string) => {
                      const check = customizeItem?.indicatorValue?.find(
                        (i: any) => renderTime(dataType, i) === y,
                      );
                      if (!!check) {
                        const valueReturn = parseFloat(
                          parseFloat(check?.value).toFixed(2),
                        );
                        return valueReturn;
                      }
                      return NaN;
                    }) || [],
                  type: customizeItem.chartType,
                  yAxis: yAxisIndex - 1,
                  zIndex:
                    customizeItem.chartType === 'line'
                      ? 2
                      : customizeItem.chartType === 'area'
                        ? 0
                        : 3,
                  dataLabels: {
                    color: 'contrast',
                    enabled: state.showIndicatorInColumn,
                    format: '{y:,.2f}',
                    ...fontSize,
                  },
                };
              }
              return {
                name: customizeItem.name || '',
                data:
                  group.map((y: string) => {
                    const check = customizeItem?.indicatorValue?.find(
                      (i: any) => renderTime(dataType, i) === y,
                    );
                    if (!!check) {
                      const valueReturn = parseFloat(
                        parseFloat(check?.value).toFixed(2),
                      );
                      return valueReturn;
                    }
                    return NaN;
                  }) || [],
                type: customizeItem.chartType,
                yAxis: yAxisIndex - 1,
                zIndex:
                  customizeItem.chartType === 'line'
                    ? 2
                    : customizeItem.chartType === 'area'
                      ? 0
                      : 3,
                dataLabels: {
                  color: 'contrast',
                  enabled: state.showIndicatorInColumn,
                  format: '{y:,.2f}',
                  ...fontSize,
                },
              };
            },
          );

          return customizeSeries;
        }

        const customizeSeries = output?.map((item: any, _: number) => {
          const findIndexUnit = listUnit.findIndex(
            (i: { id: string[]; unit: string }) =>
              i.id.includes(item.id) && i.unit === item.unit,
          );
          return {
            name: item.name || '',
            data:
              group.map((y: string) => {
                const check = item?.indicatorValue?.find(
                  (i: any) => renderTime(dataType, i) === y,
                );
                if (!!check) {
                  const valueReturn = parseFloat(
                    parseFloat(check?.value).toFixed(2),
                  );
                  return valueReturn;
                }
                return NaN;
              }) || [],
            type: ['column', 'line', 'area'].includes(item.chartType)
              ? item.chartType
              : 'column',
            zIndex: zIndexMapping[item.chartType],
            yAxis: findIndexUnit,
            dataLabels: {
              color: 'contrast',
              enabled: state.showIndicatorInColumn,
              format: '{y:,.2f}',
              ...fontSize,
            },
          };
        });

        return customizeSeries;
      case 'object':
        const seriesObject = (data?.response || data[0]?.indicatorValue)?.map(
          (item: any, index: number) => {
            return {
              name: renderTime(dataType, item),
              type: 'column',
              data:
                (data?.response || data || []).map((i: any) => {
                  if (
                    (i?.values || [])[index] ||
                    (i?.indicatorValue || [])[index]
                  )
                    return parseFloat(
                      parseFloat(
                        (
                          (i?.values || [])[index] ||
                          (i?.indicatorValue || [])[index]
                        )?.value,
                      ).toFixed(2),
                    );
                }) || [],
              dataLabels: {
                color: 'contrast',
                enabled: state.showIndicatorInColumn,
                format: '{y:,.2f}',
                ...fontSize,
              },
            };
          },
        );
        return seriesObject;
      case 'pie':
        const mostColumnPie = (data || []).reduce(
          (maxChild: any, currentChild: any) =>
            currentChild.indicatorValue?.length >
            maxChild.indicatorValue?.length
              ? currentChild
              : maxChild,
          data[0],
        );
        const list = mostColumnPie?.indicatorValue || data[0]?.values || [];
        const formatData = list?.map((item: any, index: number) => ({
          name: renderTime(dataType, item),
          colorByPoint: false,
          type: 'pie',
          data:
            (data || []).map((i: any, idx: number) => {
              const child: any = i?.indicatorValue || i?.values || [];
              const y = child[index]?.value;
              return {
                name: i.name,
                color: colors[idx],
                y: y ? parseFloat(parseFloat(y).toFixed(2)) : undefined,
              };
            }) || [],
          dataLabels: [
            {
              enabled: state.showIndicatorInColumn,
              distance: 20,
              format: '{point.name}',
              style: { fontSize: 16, opacity: 1, fontWeight: 400 },
            },
            {
              enabled: state.showIndicatorInColumn,
              inside: true,
              format: '{point.percentage:.1f}%',
              distance: -20,
              filter: { operator: '>', property: 'percentage', value: 2 },
              style: { fontSize: 16, opacity: 1, fontWeight: 400 },
            },
          ],
        }));

        setState((prev) => ({
          ...prev,
          pie: { ...prev.pie, data: formatData, max: formatData?.length },
        }));
        return (formatData || [])[state.pie.index];
      case 'group-column':
        const mostColumn = (data || []).reduce(
          (maxChild: any, currentChild: any) =>
            currentChild.indicatorValue?.length >
            maxChild.indicatorValue?.length
              ? currentChild
              : maxChild,
          data[0],
        );

        const listUnitUniqueGroupColumn: string[] = Object.values(
          Array.from(
            new Set(
              (mostColumn?.indicatorValue || []).map((item: any) => item.unit),
            ),
          ),
        );
        const seriesGroupColumn = (mostColumn?.indicatorValue || []).map(
          (item: any, index: number) => {
            const unitIndex = listUnitUniqueGroupColumn.indexOf(item.unit);
            return {
              name: item.name,
              type: 'column',
              data: data?.map((i: any) => {
                const getIndex = (i.indicatorValue || []).findIndex(
                  (y: any) => y.name === item.name,
                );
                return getIndex !== -1
                  ? i.indicatorValue[getIndex].value
                  : null;
              }),
              allowPointSelect: false,
              yAxis: unitIndex,
              zIndex: item.chartType === 'line' ? 2 : 1,
              dataLabels: {
                enabled: state.showIndicatorInColumn,
                format: '{y:,.2f}',
                color: 'contrast',
                ...fontSize,
              },
            };
          },
        );

        return seriesGroupColumn;
    }
  }, [
    data,
    name,
    colors,
    dataType,
    isTwoUnit,
    isStructure,
    state.pie.index,
    isObjectOneTime,
    state.customize.data,
    state.compare.result,
    state.customize.check,
    state.setting.type.value,
    state.showIndicatorInColumn,
  ]);

  const getLegend = useCallback(() => {
    const enabled =
      state.isHiddenHeader || (!isObjectOneTime && !isTwoUnit && !isStructure);
    const commonLegend = {
      enabled: !!state.compare.result?.length ? true : enabled ? false : true,
      x: 0,
      y: -10,
      itemStyle: {
        color: '#333333',
        cursor: 'pointer',
        fontSize: '17px',
        fontWeight: 'normal',
        textOverflow: 'ellipsis',
      },
      verticalAlign: 'top',
      layout: 'horizontal',
      rtl: false,
      align: 'left',
      reversed: false,
      maxHeight: 100,
      navigation: {
        enabled: true,
      },
      labelFormatter: function (this: any) {
        return this.name;
      },
      events: {
        itemClick: function (e: any) {},
      },
    };
    switch (state.setting.type.value) {
      case 'bar':
      case 'line':
      case 'stack-value':
      case 'stack-percent':
      case 'area':
      case 'column-line':
      case 'object':
      case 'column':
        return commonLegend;
      case 'pie':
        return {
          enabled: false,
        };
      case 'group-column':
        return commonLegend;
    }
  }, [
    state.setting.type.value,
    state.isFullscreen,
    isObjectOneTime,
    state.compare.result,
  ]);

  const getTooltip = useCallback(() => {
    switch (state.setting.type.value) {
      case 'bar':
      case 'line':
      case 'stack-value':
      case 'stack-percent':
      case 'column':
      case 'area':
      case 'column-line':
      case 'pie':
      case 'object':
        return {
          enabled: state.showIndicatorInColumn,
          shared: true,
          crosshairs: [true, true],
          backgroundColor: '#fff',
          style: { color: '#000', fontSize: '15px' },
          borderRadius: 4,
          snap: 12,
          distance: 20,
        };
      case 'group-column':
        return {
          enabled: state.showIndicatorInColumn,
          shared: true,
          crosshairs: true,
          backgroundColor: '#fff',
          style: { color: '#000', fontSize: '15px' },
          borderRadius: 4,
          snap: 12,
        };
    }
  }, [state.setting.type.value, state.showIndicatorInColumn]);

  const handleUpdateConfig = useCallback(
    (type: string) => {
      if (!type) return;
      const newConfig = {
        ...config,
      };
      const commonTitle = { text: name ?? '', align: 'left' };
      if (!state.setting.type || !state.setting.type.value) return;
      switch (type) {
        case 'bar':
        case 'line':
        case 'stack-value':
        case 'stack-percent':
        case 'group-column':
        case 'object':
        case 'area':
          setConfig({
            ...config,
            chart: chart(),
            plotOptions: plotOptions(),
            xAxis: xAxis(),
            series: getSeries(),
            title: commonTitle,
            responsive: {},
          });
          break;
        case 'column':
          setConfig({
            ...newConfig,
            chart: chart(),
            plotOptions: plotOptions(),
            xAxis: xAxis(),
            series: getSeries(),
            title: commonTitle,
            responsive: {},
            yAxis: {
              title: {
                text: '',
              },
            },
          });
          break;
        case 'column-line':
          setConfig({
            ...config,
            chart: chart(),
            yAxis: yAxis(),
            plotOptions: plotOptions(),
            series: getSeries(),
            title: commonTitle,
            responsive: {
              rules: [
                {
                  condition: {
                    maxWidth: 500,
                  },
                  chartOptions: {
                    legend: {
                      floating: false,
                      layout: 'horizontal',
                      align: 'center',
                      verticalAlign: 'bottom',
                      x: 0,
                      y: 0,
                    },
                    yAxis: [
                      {
                        labels: {
                          align: 'right',
                          x: 0,
                          y: -6,
                        },
                        showLastLabel: false,
                      },
                      {
                        labels: {
                          align: 'left',
                          x: 0,
                          y: -6,
                        },
                        showLastLabel: false,
                      },
                      {
                        visible: false,
                      },
                    ],
                  },
                },
              ],
            },
          });
          break;
        case 'pie':
          setConfig({
            ...config,
            chart: chart(),
            plotOptions: plotOptions(),
            xAxis: xAxis(),
            series: getSeries(),
            title: {
              text: `${name} - ${renderTime(dataType, (data[0]?.indicatorValue || data[0]?.values || [])[state.pie.index])} `,
              align: 'left',
            },
            responsive: {},
            legend: {
              enabled: false,
            },
          });
          break;
      }
    },
    [state.setting.type, state.customize.check, state.showIndicatorInColumn],
  );

  useEffect(() => {
    if (chartType) {
      const initType = typeChart.find((item) => item.value === chartType);
      if (initType) {
        setState((prev) => ({
          ...prev,
          setting: { ...prev.setting, type: initType },
          showIndicatorInColumn: false,
        }));
      }
    }
  }, [chartType]);

  useEffect(() => {
    setState((prev) => ({ ...prev, loading: propsLoading }));
  }, [propsLoading]);

  useEffect(() => {
    const condition =
      state.showIndicatorInColumn ||
      state.compare.open ||
      state.customize.open ||
      state.compare.result?.length > 0;
    if (condition) {
      handleSetAutoPlay(true);
    }
  }, [
    state.showIndicatorInColumn,
    state.compare.open,
    state.customize.open,
    state.compare.result,
  ]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      rangeTime: '',
      range: 12,
      compare: {
        ...prev.compare,
        open: false,
        loading: false,
        openList: false,
        pageSize: 10,
        pageIndex: 1,
        list: [],
        result: [],
        total: 0,
        keyword: '',
        value: undefined,
      },
    }));
  }, [id]);

  useEffect(() => {
    if (state.setting.type && state.setting.type.value) {
      handleUpdateConfig(state.setting.type.value);
    }
  }, [state.setting.type.value]);

  useEffect(() => {
    if (!data) return;
    const newConfig = {
      ...config,
      xAxis: xAxis(),
      series: getSeries(),
      yAxis: yAxis(),
      tooltip: getTooltip(),
      chart: chart(),
      legend: getLegend(),
      plotOptions: plotOptions(),
      colors: colors,
      title: {
        ...(state.setting.type.value === 'pie' && {
          text: `${name} ${state.isHiddenHeader ? '' : '- ' + renderTime(dataType, (data[0]?.indicatorValue || data[0]?.values || [])[state.pie.index])} `,
        }),
        ...(state.setting.type.value !== 'pie' && { text: name ?? '' }),
        align: 'left',
        style: {
          textTransform: 'uppercase',
        },
      },
      caption: {
        text: `© Vietstats ${new Date().getFullYear()} | Nguồn dữ liệu: ${original || ''} | Tổng hợp: ${originalUrl || ''} `,
        style: {
          fontSize: innerWidth > 1199 ? captionSize : 16,
          color: '#0489dc',
          transform: 'translateX(-1px)',
          width: '100%',
        },
        x: state.isHiddenHeader ? -5 : 0,
        y: 14,
      },
      credits: { enabled: false },
      boost: {
        enabled: true,
        allowForce: true,
        pixelRatio: 1,
        useGPUTranslations: true,
        usePreallocated: true,
        seriesThreshold: 100,
        debug: {
          showSkipSummary: true,
          timeSeriesProcessing: true,
        },
      },
    };
    setConfig(newConfig);
  }, [
    data,
    state.isFullscreen,
    state.showIndicatorInColumn,
    state.pie.index,
    state.setting.type.value,
    state.loading,
    state.isHiddenHeader,
    captionSize,
    state.compare.result,
    state.customize.check,
    state.customize.data,
  ]);

  useEffect(() => {
    if (chartType) {
      const initType = chartDefined.find((item) => {
        if (isObjectOneTime) return item.value === 'group-column';
        return item.value === chartType;
      });
      if (initType) {
        setState((prev) => ({
          ...prev,
          setting: { ...prev.setting, type: initType },
        }));
      }
    }
  }, [id]);

  useEffect(() => {
    if (state.downloadSuccess) fetchNewPlan();
  }, [state.downloadSuccess]);

  useEffect(() => {
    const itemActive = document.querySelector(
      '.t-chart_package_content-pie_item-active',
    );
    itemActive?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }, [state.pie.index]);

  useEffect(() => {
    setState((prev) => ({ ...prev, loading: true }));
    const timeout = setTimeout(
      () => setState((prev) => ({ ...prev, loading: false })),
      100,
    );
    return () => clearTimeout(timeout);
  }, [data]);

  const renderTimePie = useMemo(() => {
    const mostColumnPie = (data || []).reduce(
      (maxChild: any, currentChild: any) =>
        currentChild.indicatorValue?.length > maxChild.indicatorValue?.length
          ? currentChild
          : maxChild,
      data[0],
    );

    if (mostColumnPie?.indicatorValue?.length <= 1 || state.isHiddenHeader)
      return;
    return (
      <div
        className={mapModifiers(
          't-chart_package_content-pie_wrapper',
          (data[0]?.indicatorValue || data[0]?.values || []).length < 6 &&
            'small',
        )}
      >
        <div
          className={mapModifiers(
            't-chart_package_content-pie_prev',
            state.pie.index === 0 && 'disable',
          )}
          onClick={() => {
            if (state.pie.index > 0) {
              setState((prev) => ({
                ...prev,
                pie: { ...prev.pie, index: prev.pie.index - 1 },
              }));
            }
          }}
        >
          <FiChevronLeft />
        </div>
        {isObjectOneTime ? (
          <ul>
            {mostColumnPie?.indicatorValue?.map((item: any, index: number) => (
              <li
                key={index}
                className={mapModifiers(
                  't-chart_package_content-pie_item_onetime',
                  index === state.pie.index && 'active',
                )}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    pie: { ...prev.pie, index },
                  }));
                }}
              >
                {item.name}
              </li>
            ))}
          </ul>
        ) : (
          <ul>
            {(mostColumnPie?.indicatorValue || data[0]?.values || [])?.map(
              (item: any, index: number) => {
                return (
                  <li
                    key={index}
                    className={mapModifiers(
                      't-chart_package_content-pie_item',
                      index === state.pie.index && 'active',
                    )}
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        pie: { ...prev.pie, index },
                      }));
                    }}
                  >
                    {renderTime(dataType, item)}
                  </li>
                );
              },
            )}
          </ul>
        )}
        <div
          className={mapModifiers(
            't-chart_package_content-pie_next',
            state.pie.index === state.pie.max - 1 && 'disable',
          )}
          onClick={() => {
            if (state.pie.index < state.pie.max - 1) {
              setState((prev) => ({
                ...prev,
                pie: { ...prev.pie, index: prev.pie.index + 1 },
              }));
            }
          }}
        >
          <FiChevronRight />
        </div>
      </div>
    );
  }, [data, state.pie.index, state.pie.max, isObjectOneTime, dataType]);

  const renderChart = useMemo(() => {
    if (state.loading) {
      return (
        <div
          className="t-chart_package_loading"
          style={{
            height: innerWidth < 600 ? 500 : 706,
          }}
        >
          <Spin />
        </div>
      );
    }

    if (!state.loading && !data.length) {
      return (
        <div
          className="t-chart_package_no-data"
          style={{ height: innerWidth < 600 ? 500 : chartHeight + 200 }}
        >
          <Empty description="Không tìm thấy dư liệu thống kê ...!" />
        </div>
      );
    }

    return (
      <React.Fragment>
        {state.setting.type.value === 'pie' && renderTimePie}
        <HighChartsReact
          highcharts={HighCharts}
          options={config as any}
          allowChartUpdate={true}
          ref={chartRef}
        />
      </React.Fragment>
    );
  }, [
    config,
    config.series,
    config.xAxis.categories,
    data,
    chartRef,
    state.loading,
  ]);

  const handleDownloadOption = useCallback(
    (option: string) => {
      if (!chartRef.current) return;
      const filename = { filename: `${slugifyFileName(name)}` };
      const chartOption: any = {
        title: {
          text: name,
          style: {
            fontSize: '26px',
            fontWeight: 'bold',
            marginBottom: 12,
          },
        },
        chart: { backgroundColor: '#FFFFFF' },
        xAxis: {
          labels: {
            style: {
              fontSize: '22px',
            },
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: '22px',
            },
          },
        },
        caption: {
          style: {
            fontSize: '24px',
          },
        },
        plotOptions: {
          series: {
            dataLabels: {
              style: {
                fontSize: '22px',
              },
            },
          },
        },
      };

      const chart = (chartRef.current as any).chart;
      switch (option) {
        case 'downloadPNG':
        case 'downloadJPEG':
        case 'downloadSVG':
          chart?.exportChartLocal(
            {
              type:
                option === 'downloadPNG'
                  ? 'image/png'
                  : option === 'downloadJPEG'
                    ? 'image/jpeg'
                    : 'image/svg+xml',
              ...filename,
              scale: 2,
            },
            chartOption,
          );
          break;
        case 'downloadPDF':
          chart?.exportChartLocal(
            {
              type: 'application/pdf',
              ...filename,
              allowHTML: true,
              scale: 2,
              chartOptions: chartOption,
            },
            chartOption,
          );
          break;
        case 'downloadXLS':
          setState((prev) => ({ ...prev, loadingDownload: true }));
          parseToExport(
            data,
            original,
            name,
            unit,
            isTwoUnit,
            isStructure,
            isObjectOneTime,
            dataType as any,
            chartType,
          ).finally(() => {
            setTimeout(
              () => setState((prev) => ({ ...prev, loadingDownload: false })),
              800,
            );
          });
          break;
        case 'fullScreen':
          setState((prev) => ({ ...prev, isFullscreen: true }));
          chart.fullscreen.open();
          break;
        case 'downloadCSV':
          if (chart) {
            HighCharts.addEvent(chart, 'exportData', function (e: any) {
              e.dataRows[0] = e.dataRows[0].map((header: string) =>
                header === 'Category' ? 'Thời gian' : header,
              );
              e.dataRows = e.dataRows.map((row: any[]) =>
                row.map((cell: any) => `${cell} `),
              );
            });
            chart.downloadCSV();
          }
          break;
      }
    },
    [
      chartRef,
      data,
      original,
      name,
      unit,
      isTwoUnit,
      isStructure,
      isObjectOneTime,
      dataType,
      chartType,
    ],
  );

  const getRange = () => {
    switch (dataType) {
      case 'year':
        return rangeYear;
      case 'month':
        return rangeMonthQuarter;
      case 'quarter':
        return rangeMonthQuarter;
      case 'day':
        return rangeDay;
      default:
        return rangeMonthQuarter;
    }
  };

  useEffect(() => {
    if (!state.customize.check) return;
    handleUpdateConfig('column-line');
  }, [state.customize.check]);

  useDebounce(
    () => {
      if (!state.compare.keyword.length) return;
      handleGetCompareList(state.compare.keyword);
    },
    1000,
    [state.compare.keyword],
  );

  const handleGetCompareList = async (keyword?: string, pageIndex?: number) => {
    if (!state.compare.open) return;
    const body = {
      id: parentId,
      type: typeData,
      dataType: dataType,
      pageSize: state.compare.pageSize,
      pageIndex: pageIndex ? pageIndex : state.compare.pageIndex,
      keyword: !!keyword?.length ? keyword : state.compare.keyword,
    };
    if (!state.compare.list.length || !!keyword?.length) {
      setState((prev) => ({
        ...prev,
        compare: { ...prev.compare, loading: true },
      }));
      await getCompareList(body).then((result: ResponseCompareData) => {
        if (!result?.records.length) {
          notify('warning', 'Không tìm thấy dữ liệu', 'top-center');
          setState((prev) => ({
            ...prev,
            compare: {
              ...prev.compare,
              list: [],
              total: 0,
              openList: false,
              loading: false,
            },
          }));
          return;
        }
        const newList = result?.records?.map((item) => ({
          value: item.name,
          label: item.name,
          id: item.id,
          type: item.type,
        }));
        setState((prev) => ({
          ...prev,
          compare: {
            ...prev.compare,
            list: newList,
            total: result?.total,
            openList: true,
            loading: false,
          },
        }));
      });
    } else {
      setState((prev) => ({
        ...prev,
        compare: { ...prev.compare, openList: true, loading: false },
      }));
    }
  };

  const handleGetCompareMore = async (pageIndex: number) => {
    const body = {
      id: parentId,
      type: typeData,
      dataType: dataType,
      pageSize: state.compare.pageSize,
      pageIndex: pageIndex,
      keyword: state.compare.keyword,
    };
    await getCompareList(body).then((result: any) => {
      const newList = result?.records?.map((item: any) => ({
        value: item.name,
        label: item.name,
        id: item.id,
        type: item.type,
      }));
      setState((prev) => ({
        ...prev,
        compare: {
          ...prev.compare,
          list: newList,
          total: result.total,
          loading: false,
          pageIndex,
        },
      }));
    });
  };

  const handleGetCompareDetail = async (id: string, type: string) => {
    const body = {
      id: id,
      type: type,
      rangeTime: !state.rangeTime
        ? state.range
        : Number(
            state.rangeTime.replace('M', '').replace('Q', '').replace('Y', ''),
          ) *
          Number({ month: 12, quarter: 4, day: 365, year: 1 }[dataType] || 1),
    };

    await getCompareDetail(body).then((result: any) => {
      const newResult = [...state.compare.result, result];
      setState((prev) => ({
        ...prev,
        compare: {
          ...prev.compare,
          result: newResult,
          openList: false,
          open: false,
        },
      }));
    });
  };

  const handleRegisterAPI = async () => {
    setState((prev) => ({ ...prev, api: { ...prev.api, loading: true } }));
    const response = await checkDownloadStatus({
      type: 'api',
      groupData: mappingGroupData[typeData],
    });

    if (response?.status) {
      const { data } = response;
      if (data?.downLoadStatus) {
        await registerAPI({ id: id, type: typeData })
          .then((result: any) => {
            if (result.status) {
              notify(
                'success',
                'Đăng ký thành công, Vui lòng kiểm tra mail để nhận thông tin tích hợp API nhé ❤!',
                'top-center',
                8000,
              );
            } else {
              notify(
                'error',
                'Đăng ký không thành công, Vui lòng kiểm tra lại gói dịch vụ',
                'top-center',
                7000,
              );
            }
          })
          .finally(() => {
            setState((prev) => ({
              ...prev,
              api: { ...prev.api, loading: false, open: false },
            }));
          });
      } else {
        notify('info', 'Bạn đã hết lượt đăng kí API');
        setState((prev) => ({
          ...prev,
          api: { ...prev.api, loading: false, open: false },
        }));
      }
    } else {
      if (response.key === 'unauthorized') {
        setState((prev) => ({
          ...prev,
          api: { ...prev.api, loading: false, open: false },
        }));
        handleOpenUnauthorized();
      } else {
        notify('warning', 'Xảy ra lỗi khi tải ảnh', 'top-right');
        setState((prev) => ({
          ...prev,
          api: { ...prev.api, loading: false, open: false },
        }));
      }
    }
  };

  const handleCheckStatus = async () => {
    try {
      const res = await checkDownloadStatus({
        type: 'ai_data_analysis',
        groupData: 'ai_data_analysis',
      });

      if (res?.status) {
        if (res?.data?.downLoadStatus) {
          handleSetStatusAssitant('popup');
          handleSetDataQuestion(generateGUID());
        } else {
          notify(
            'warning',
            'Bạn đã hết lượt phân dữ liệu với AI',
            'top-center',
          );
        }
      } else {
        if (res.key === 'unauthorized') {
          handleOpenUnauthorized();
        } else {
          setState((prev) => ({
            ...prev,
            modal: {
              ...prev.modal,
              title: 'Phân tích chỉ số với AI Chatbot',
              open: true,
            },
          }));
        }
      }
    } catch (error) {
      console.error('Error in handleCheckStatus:', error);
    }
  };

  const renderCustomizeChart = useMemo(() => {
    return (
      <div
        className={mapModifiers(
          't-chart_package_chart_cusomize',
          state.customize.open ? 'open' : 'close',
        )}
      >
        <div className={mapModifiers('t-chart_package_chart_cusomize_heading')}>
          <h2>Tùy chọn chỉ số hiển thị</h2>
        </div>
        <Table
          columns={[
            {
              title: 'Tên dữ liệu',
              dataIndex: 'name',
              align: 'start',
              render: (record: any, data: any) => <div>{record || ''}</div>,
            },
            {
              title: 'Loại chart',
              dataIndex: 'chartType',
              align: 'center',
              width: 180,
              render: (record: any, data: any, index: number) => {
                const options = [
                  {
                    id: 0,
                    icon: 'column_chart',
                    label: 'Biểu đồ cột dọc',
                    value: 'column',
                  },
                  {
                    id: 1,
                    icon: 'line_chart',
                    label: 'Biểu đồ dây',
                    value: 'line',
                  },
                  {
                    id: 2,
                    icon: 'line_chart',
                    label: 'Biểu đồ vùng',
                    value: 'area',
                  },
                ];
                const valueDefault = options.find((i) => i.value === record);
                return (
                  <div
                    className={mapModifiers(
                      't-chart_package_chart_cusomize_select',
                    )}
                  >
                    <Select
                      className="select-type-chart"
                      placeholder="Chọn chart muốn hiển thị"
                      options={options}
                      value={valueDefault}
                      onChange={(item: any) => {
                        const newData = state.customize.data.map(
                          (ytem: any, idx: number) => {
                            if (index === idx) {
                              return { ...ytem, chartType: item.value };
                            }
                            return ytem;
                          },
                        );
                        setState((prev) => ({
                          ...prev,
                          customize: { ...prev.customize, data: newData },
                        }));
                      }}
                    />
                  </div>
                );
              },
            },
            {
              title: 'Thêm cột đơn vị',
              dataIndex: 'isYAxis',
              align: 'center',
              width: 150,
              render: (record: any, data: any, index: number) => (
                <div
                  className={mapModifiers(
                    't-chart_package_chart_cusomize_check',
                  )}
                >
                  <Checkbox
                    checked={record}
                    handleOnCheck={(event) => {
                      const newData = state.customize.data.map(
                        (ytem: any, idx: number) => {
                          if (index === idx) {
                            return { ...ytem, isYAxis: event.target.checked };
                          }
                          return ytem;
                        },
                      );
                      setState((prev) => ({
                        ...prev,
                        customize: { ...prev.customize, data: newData },
                      }));
                    }}
                  />
                </div>
              ),
            },
          ]}
          dataSource={state.customize.data}
          bordered
          pagination={false}
          size="small"
        />
        <div className={mapModifiers('t-chart_package_chart_cusomize_footing')}>
          <Button
            shape="fill"
            ariaLabel="Hủy"
            variant="danger"
            onClick={() => {
              setState((prev) => ({
                ...prev,
                customize: {
                  ...prev.customize,
                  data: undefined,
                  open: false,
                  check: false,
                },
              }));
            }}
          >
            Hủy
          </Button>
          <Button
            ariaLabel="Lưu thông tin"
            shape="fill"
            variant="secondary"
            onClick={() => {
              setState((prev) => ({
                ...prev,
                customize: { ...prev.customize, check: true, open: false },
              }));
              // handleUpdateConfig('column-line');
            }}
          >
            Lưu
          </Button>
        </div>
      </div>
    );
  }, [state.customize, state.customize.open]);

  const renderSearchIndicatorToCompare = useMemo(() => {
    return (
      <div
        className={mapModifiers(
          't-chart_package_chart_compare',
          state.compare.open ? 'open' : 'close',
        )}
      >
        <div className={mapModifiers('t-chart_package_chart_compare_heading')}>
          <h2>So sánh chỉ số</h2>
        </div>
        <AutoComplete
          open={state.compare.openList}
          options={
            state.compare.loading
              ? [
                  {
                    value: 'loading',
                    label: (
                      <Skeleton
                        active
                        type="default"
                        loading
                        paragraph={{ rows: 6, width: '100%' }}
                      />
                    ),
                  },
                ]
              : state.compare.list
          }
          placeholder={`🔎 Chọn chỉ số bạn muốn so sánh với ${name}`}
          value={state.compare.keyword}
          showMore={state.compare.total > state.compare.pageSize}
          allowClear
          showSearch
          onFocus={() => {
            if (state.compare.open) {
              handleGetCompareList();
            }
          }}
          onSelect={(item: any, option: any) => {
            const newList = state.compare.list.filter(
              (y: any) => y.id !== option.id,
            );
            if (!newList.length) {
              const checkExit = state.compare.listPageDisable.includes(
                state.compare.pageIndex,
              );
              setState((prev) => ({
                ...prev,
                compare: {
                  ...prev.compare,
                  pageIndex: 1,
                  keyword: '',
                  list: [],
                  listPageDisable: [
                    ...prev.compare.listPageDisable,
                    ...(checkExit ? [] : [prev.compare.pageIndex]),
                  ],
                },
              }));
              handleGetCompareDetail(option.id, option.type);
            } else {
              setState((prev) => ({
                ...prev,
                compare: {
                  ...prev.compare,
                  list: !newList.length ? [] : newList,
                  keyword: '',
                },
              }));
              handleGetCompareDetail(option.id, option.type);
            }
          }}
          onSearch={(text) => {
            setState((prev) => ({
              ...prev,
              compare: { ...prev.compare, keyword: text },
            }));
          }}
          listHeight={340}
          renderShowMore={
            <Pagination
              pageSize={state.compare.pageSize}
              current={state.compare.pageIndex}
              total={state.compare.total}
              pageDisable={Array.from(new Set(state.compare.listPageDisable))}
              onChange={(page: number, pageSize: number) => {
                setState((prev) => ({
                  ...prev,
                  compare: { ...prev.compare, loading: true },
                }));
                handleGetCompareMore(page);
              }}
            />
          }
        />
      </div>
    );
  }, [
    state.compare,
    state.compare.openList,
    state.compare.result,
    state.compare.list,
  ]);

  const renderListCompare = useMemo(() => {
    if (!state.compare.result) return <ul>nothing</ul>;
    return (
      <Table
        columns={[
          {
            title: 'Tên dữ liệu',
            dataIndex: 'name',
            align: 'start',
            render: (record: any, data: any) => <div>{record || ''}</div>,
          },
          {
            title: 'Xóa',
            dataIndex: 'name',
            align: 'center',
            width: 150,
            render: (record: any, data: any) => {
              return (
                <div
                  className={mapModifiers(
                    't-chart_package_chart_cusomize_check',
                  )}
                >
                  {data?.id ? (
                    <FaTrash
                      style={{
                        color: '#f00',
                        fontSize: 18,
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        const newList = state.compare.result.filter(
                          (ytem: any) => ytem.id !== data.id,
                        );
                        setState((prev) => ({
                          ...prev,
                          compare: { ...prev.compare, result: newList },
                        }));
                      }}
                    />
                  ) : null}
                </div>
              );
            },
          },
        ]}
        isExpandable
        childrenColumnName={'nest'}
        dataSource={[{ name: name }, ...state.compare.result]}
        bordered
        pagination={false}
        size="middle"
      />
    );
  }, [state.compare.result]);

  const handleDownloadWithStatus = async (
    type: string,
    title: string,
    downloadKey: string,
  ) => {
    const res = await checkDownloadStatus({
      type,
      groupData: mappingGroupData[typeData],
    });

    if (res.status && res?.data?.downLoadStatus) {
      handleDownloadOption(downloadKey);
      setState((prev) => ({
        ...prev,
        downloadSuccess: true,
      }));
    } else {
      if (res.key === 'unauthorized') {
        handleOpenUnauthorized();
      } else {
        setState((prev) => ({
          ...prev,
          modal: {
            ...prev.modal,
            title,
            open: true,
          },
        }));
      }
    }
  };

  return (
    <div
      className={mapModifiers(
        't-chart_package',
        isPageDetail ? 'detail' : 'other',
        state.loading ? 'loading' : '',
      )}
      ref={chartWrapperRef}
    >
      {!state.isHiddenHeader && (
        <div className="t-chart_package_header">
          <div className="t-chart_package_header_left">
            <Select
              className="select-type-chart"
              popupMatchSelectWidth={250}
              withIcon
              listHeight={320}
              isMobile={innerWidth < 1500}
              showSearch={innerWidth > 600}
              placeholder="Chọn chart muốn hiển thị"
              options={
                isObjectOneTime
                  ? [
                      {
                        id: 6,
                        icon: 'column_chart',
                        label: 'Biểu đồ cột dọc',
                        value: 'group-column',
                      },
                      {
                        id: 2,
                        icon: 'line_chart',
                        label: 'Biểu đồ dây',
                        value: 'line',
                      },
                      {
                        id: 8,
                        icon: 'pie-chart',
                        label: 'Biểu đồ tròn',
                        value: 'pie',
                      },
                      {
                        id: 3,
                        icon: 'stack_value',
                        label: 'Biểu đồ cơ cấu giá trị',
                        value: 'stack-value',
                      },
                      {
                        id: 4,
                        icon: 'stacked_bar',
                        label: 'Biểu đồ cơ cấu 100%',
                        value: 'stack-percent',
                      },
                    ]
                  : ([
                      ...typeChart,
                      ...(isStructure
                        ? [
                            {
                              id: 6,
                              icon: 'object_chart',
                              label: 'Biểu đồ so sánh chéo',
                              value: 'object',
                            },
                            {
                              id: 8,
                              icon: 'pie-chart',
                              label: 'Biểu đồ tròn',
                              value: 'pie',
                            },
                            {
                              id: 5,
                              icon: 'dual_axes',
                              label: 'Biểu đồ hỗn hợp',
                              value: 'column-line',
                            },
                          ]
                        : []),
                    ] as ISelectType[])
              }
              value={state.setting.type as ISelectType}
              onChange={(item: any) => {
                if (userData?.user?.permission?.isViewOptionChart) {
                  if (item)
                    setState((prev) => ({
                      ...prev,
                      setting: { ...prev.setting, type: item },
                    }));
                } else
                  setState((prev) => ({
                    ...prev,
                    modal: {
                      ...prev.modal,
                      title: 'Tùy chọn hiển thị dạng biểu đồ',
                      open: true,
                    },
                  }));
              }}
            />
            {innerWidth > 800 ? (
              <div className="t-chart_package_header_time">
                {!['pie', 'group-column'].includes(
                  state.setting.type.value as string,
                ) &&
                  !isObjectOneTime &&
                  id &&
                  getRange()?.map((button) => (
                    <button
                      aria-label="Chọn mốc thời gian"
                      className={mapModifiers(
                        't-chart_package_header_time_button',
                        state.rangeTime === button?.label && 'active',
                      )}
                      key={button.id}
                      onClick={() => {
                        if (userData?.user?.permission?.isViewMoreRangeData) {
                          handleClickRangeTime({
                            id: id,
                            range_time: button?.value,
                          });
                          setState((prev) => ({
                            ...prev,
                            rangeTime: button?.label,
                            compare: { ...prev.compare, result: [] },
                            modal: {
                              title: '',
                              open: false,
                            },
                          }));
                        } else
                          setState({
                            ...state,
                            modal: {
                              title: 'Tùy chọn hiển thị khoảng dữ liệu',
                              open: true,
                            },
                          });
                      }}
                    >
                      {button.label}
                    </button>
                  ))}
              </div>
            ) : !isObjectOneTime ? (
              <div
                className={
                  't-chart_package_header_select t-chart_package_header_time'
                }
              >
                <Dropdown
                  options={{
                    items: [
                      { label: '5Y', key: '5' },
                      { label: '10Y', key: '10' },
                      { label: '20Y', key: '20' },
                      { label: '30Y', key: '30' },
                      { label: 'MAX', key: 'max' },
                    ],

                    onClick: (info) => {
                      if (userData?.user?.permission?.isViewMoreRangeData) {
                        setState((prev) => ({
                          ...prev,
                          range: Number(info.key),
                          compare: { ...prev.compare, result: [] },
                        }));
                        handleClickRangeTime({
                          id: id,
                          range_time: Number(info.key),
                        });
                      } else
                        setState({
                          ...state,
                          modal: {
                            ...state.modal,
                            title: 'Tùy chọn hiển thị khoảng dữ liệu',
                            open: true,
                          },
                        });
                    },
                  }}
                >
                  <span className="t-chart_package_header_select_time">
                    {(Number.isNaN(state.range)
                      ? 'MAX'
                      : state.range
                    ).toString()}
                    {Number.isNaN(state.range) ? '' : mappingType[dataType]}
                  </span>
                </Dropdown>
              </div>
            ) : null}
          </div>
          <div className="t-chart_package_header_right">
            {state.setting.type.value === 'column-line' &&
              innerWidth > 600 &&
              !state.customize.check && (
                <Checkbox
                  className="t-chart_package_header_right_customize"
                  checked={state.customize.open}
                  handleOnCheck={(event) => {
                    if (!userData?.user) {
                      setState((prev) => ({
                        ...prev,
                        modal: {
                          ...prev.modal,
                          title: 'Tùy chỉnh chart hiển thị chỉ số',
                          open: true,
                        },
                      }));
                    } else {
                      const newData: any = [];
                      data.map((item: any) => {
                        const checkExit = newData.some(
                          (i: any) => i.unit === item.unit,
                        );
                        if (!checkExit) {
                          newData.push({
                            ...item,
                            chartType: item.chartType,
                            isYAxis: true,
                          });
                          return;
                        }
                        newData.push(item);
                      });

                      setState((prev) => ({
                        ...prev,
                        customize: {
                          ...prev.customize,
                          open: event.target.checked,
                          data: event.target.checked ? newData : undefined,
                        },
                      }));
                    }
                  }}
                  label={'Tùy chỉnh biểu đồ'}
                />
              )}
            {state.setting.type.value === 'column-line' &&
              state.customize.check && (
                <div
                  className={mapModifiers(
                    't-chart_package_header_right_view_data',
                    state.compare.open && 'active',
                  )}
                  style={{ display: 'flex', alignItems: 'center' }}
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      customize: {
                        ...prev.customize,
                        open: false,
                        check: false,
                        data: undefined,
                      },
                    }));
                  }}
                >
                  <FaRotate className={mapModifiers('download-icon', 'eye')} />
                  {innerWidth > 950 && <p>Xóa tùy chỉnh</p>}
                </div>
              )}

            <div
              className={mapModifiers(
                't-chart_package_header_action',
                innerWidth > 800 ? 'desktop' : 'mobile',
              )}
            >
              {isPageDetail && (
                <div
                  className={mapModifiers(
                    't-chart_package_header_right_view_data',
                    'api',
                  )}
                  style={{ display: 'flex', alignItems: 'center' }}
                  onClick={handleCheckStatus}
                >
                  <FaReact className={mapModifiers('download-icon', 'api')} />
                  {innerWidth > 950 && <p>Phân tích với AI</p>}
                </div>
              )}
              <div
                className={mapModifiers(
                  't-chart_package_header_right_view_data',
                  'api',
                )}
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  if (userData?.user?.permission?.isViewMoreRangeData) {
                    setState((prev) => ({
                      ...prev,
                      api: { ...prev.api, open: true, loading: false },
                    }));
                  } else
                    setState((prev) => ({
                      ...prev,
                      modal: {
                        ...prev.modal,
                        title: 'Đăng kí API ',
                        open: true,
                      },
                    }));
                }}
              >
                <BsDatabaseCheck
                  className={mapModifiers('download-icon', 'api')}
                />
                {innerWidth > 950 && <p>API</p>}
              </div>
              {['line', 'column'].includes(chartType) &&
                !isObjectOneTime &&
                isPageDetail &&
                !isTwoUnit &&
                isPageDetail &&
                !isStructure && (
                  <div
                    className={mapModifiers(
                      't-chart_package_header_right_view_data',
                      state.compare.open && 'active',
                    )}
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        compare: { ...prev.compare, open: !prev.compare.open },
                      }));
                    }}
                  >
                    <FaRegSquarePlus
                      className={mapModifiers('download-icon', 'eye')}
                    />
                    {innerWidth > 950 && <p>So sánh</p>}
                  </div>
                )}
              <div
                className={mapModifiers(
                  't-chart_package_header_right_view_data',
                  'eye',
                )}
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  if (!!userData?.user) {
                    setState((prev) => ({
                      ...prev,
                      showIndicatorInColumn: !prev.showIndicatorInColumn,
                    }));
                  } else {
                    setState((prev) => ({
                      ...prev,
                      modal: {
                        ...prev.modal,
                        title: 'Hiển thị chỉ số trên biểu đồ',
                        open: true,
                      },
                    }));
                  }
                }}
              >
                {!state.showIndicatorInColumn ? (
                  <FaRegEye className={mapModifiers('download-icon', 'eye')} />
                ) : (
                  <FaRegEyeSlash
                    className={mapModifiers('download-icon', 'eye')}
                  />
                )}
                {innerWidth > 950 && <p>Xem dữ liệu</p>}
              </div>
              {innerWidth > 800 && (
                <div
                  className={mapModifiers(
                    't-chart_package_header_right_view_data',
                    'fullscreen',
                  )}
                  onClick={() => {
                    if (!userData?.user) {
                      setState((prev) => ({
                        ...prev,
                        modal: {
                          ...prev.modal,
                          title: 'Hiển thị chỉ số toàn màng hình',
                          open: true,
                        },
                      }));
                    } else {
                      handleDownloadOption('fullScreen');
                    }
                  }}
                >
                  <AiOutlineFullscreen
                    className={mapModifiers('download-icon', 'full-screen')}
                  />
                  {innerWidth > 950 && <p>Toàn màn hình</p>}
                </div>
              )}
              <Dropdown
                options={{
                  items: itemsMenu,
                  onClick: async (info) => {
                    setState((prev) => ({ ...prev, downloadSuccess: false }));
                    switch (info.key) {
                      case 'downloadCSV':
                      case 'downloadXLS':
                        await handleDownloadWithStatus(
                          'excel',
                          'Download biểu đồ dạng Excel/CSV',
                          info.key,
                        );
                        break;
                      case 'downloadPNG':
                      case 'downloadJPEG':
                        await handleDownloadWithStatus(
                          'image_pdf',
                          'Download biểu đồ dạng PNG/JPEG',
                          info.key,
                        );
                        break;
                      default:
                        await handleDownloadWithStatus(
                          'pdf_svg',
                          'Download biểu đồ dạng PDF/SVG',
                          info.key,
                        );
                    }
                  },
                }}
              >
                {state.loadingDownload ? (
                  <AntSpin
                    size="small"
                    className={mapModifiers(
                      't-chart_package_header_action_download',
                      state.loadingDownload && 'active',
                    )}
                  />
                ) : (
                  <div
                    className={mapModifiers(
                      't-chart_package_header_right_view_data',
                      'download',
                    )}
                  >
                    <FiDownload
                      className={mapModifiers(
                        'download-icon',
                        'download-indicator',
                      )}
                    />
                    {innerWidth > 950 && <p>Tải dữ liệu</p>}
                  </div>
                )}
              </Dropdown>
              {innerWidth > 860 && !isPageDetail && (
                <a
                  className={mapModifiers(
                    't-chart_package_header_right_view_data',
                    'to-detail',
                    state.compare.open && 'active',
                  )}
                  style={{ display: 'flex', alignItems: 'center' }}
                  href={`/thong-tin-chi-tiet/${slug}/${id}?type=${typeData}&structure=${isStructure}&isObjectOneTime=${isObjectOneTime}`}
                >
                  <FaArrowUpRightFromSquare
                    style={{ fontSize: 18 }}
                    className={mapModifiers('download-icon', 'eye')}
                  />
                  {innerWidth > 860 && <p>Xem chi tiết</p>}
                </a>
              )}
            </div>
          </div>
        </div>
      )}
      {renderCustomizeChart}
      {!isObjectOneTime &&
        !isTwoUnit &&
        !isStructure &&
        renderSearchIndicatorToCompare}
      <div
        className={mapModifiers(
          't-chart_package_content',
          !data && 'no-data',
          state.setting.type.value?.toString(),
        )}
      >
        {renderChart}
        {isPageDetail && !!state.compare.result.length && renderListCompare}
      </div>
      <PermissionModal
        open={state.modal.open}
        onCancel={() => {
          setState((prev) => ({
            ...prev,
            modal: { ...prev.modal, open: false },
          }));
        }}
        title={state.modal.title}
      />
      <PopupConfirm
        title="Xác nhận đăng kí API"
        message={'Bạn chắc chắc muốn đăng kí API với chỉ số ' + name}
        open={state.api.open}
        cancelText="Hủy"
        confirmText="Đồng ý"
        loading={state.api.loading}
        onCancel={() => {
          setState((prev) => ({
            ...prev,
            api: { ...prev.api, open: false, loading: false },
          }));
        }}
        onConfirm={handleRegisterAPI}
      />
    </div>
  );
};

export default ChartPackage;
